import { Flex } from "antd";
import { useState } from "react";

import { UniversalTabs } from "@/components/UniversalTabs";
import Payments from "@/pages/Dashboard/DashboardTabs/Payments";
import Sales from "@/pages/Dashboard/DashboardTabs/Sales";

import { SelfPlan } from "./SelfPlan";

type TabValue = "personal-plan" | "sales" | "payments";

const tabsConfig: { value: TabValue; label: string }[] = [
    { value: "personal-plan", label: "Персональний план" },
    { value: "sales", label: "Продажі" },
    { value: "payments", label: "Оплати" },
];

interface DashboardTabsProps {
    userId: string;
}

const DashboardTabs = ({ userId }: DashboardTabsProps) => {
    const [currentTab, setCurrentTab] = useState<TabValue>("personal-plan");

    const renderTabContent = (tab: TabValue) => {
        switch (tab) {
            case "personal-plan":
                return <SelfPlan targetDB="db-ta" />;
            case "sales":
                return <Sales userId={userId} />;
            case "payments":
                return <Payments userId={userId} />;
            default:
                return null;
        }
    };

    return (
        <Flex
            vertical
            gap="16px"
            flex={1}
            style={{ position: "relative", minHeight: 0, width: "100%" }}
        >
            <UniversalTabs
                value={currentTab}
                onChange={(val: TabValue) => setCurrentTab(val)}
                tabs={tabsConfig}
                maxWidth="340px"
            />

            {renderTabContent(currentTab)}
        </Flex>
    );
};

export default DashboardTabs;
